// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* App.css */
body {
  font-family: Arial, sans-serif;
}

h1 {
  text-align: center;
  font-size: larger!important;
}

button {
  margin: 5px;
  padding: 10px;
  font-size: 16px;
}

div {
  text-align: center;
}

.journey-map-container {
  position: relative;
  display: inline-block;
}

.journey-map-container img {
  width: 100%;
  height: auto;
}

.clickable-area {
  position: absolute;
  cursor: pointer;
  /* Adjust the width, height, and positioning for each stage */
}

.stage0 {
  top: 28%;
  left: 5%;
  width: 19%;
  height: 20%;
}


.stage1 {
  top: 35%;
  left: 22%;
  width: 20%;
  height: 20%;
}

.stage2 {
  top: 55%;
  left: 23%;
  width: 16%;
  height: 20%;
}

.stage3 {
  top: 25%;
  left: 42%;
  width: 15%;
  height: 24%;
}

.stage4 {
  top: 50%;
  left: 42%;
  width: 17%;
  height: 20%;
}

.stage5 {
  top: 40%;
  left: 60%;
  width: 17%;
  height: 17%;
}

.stage6 {
  top: 56%;
  left: 60%;
  width: 17%;
  height: 17%;
}

.stage7 {
  top: 20%;
  left: 80%;
  width: 16%;
  height: 40%;
}

/* Add more styles for other stages */

.tooltip {
  visibility: hidden;
  background-color: green;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 125%; /* Position the tooltip above the clickable area */
  left: 50%;
  margin-left: -60px;
  width: 120px;
}

.tooltip .tooltip-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.clickable-area {
  position: absolute;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.clickable-area:hover {
  transform: scale(1.05);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.tooltip p {
  display: inline-block;
  vertical-align: middle;
  margin: 0;
}
.tooltip:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: green;
  color: white;
  padding: 10px;
  border-radius: 5px;
  white-space: nowrap;
  z-index: 1000;
  display: flex;
  align-items: center;
}

.tooltip:hover .tooltip-avatar {
  display: inline-block;
}

.tooltip:hover p {
  visibility: visible;
  opacity: 1;
}

.clickable-area:hover .tooltip {
  visibility: visible;
}

.stage-content {
  margin-top: 20px;
  opacity: 0;
  animation: fadeIn 1s forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* App.css */
.journey-map-container {
  position: relative;
}

.avatar-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 2;
}

.selected-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.chat-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #0078d4;
  border: none;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: white;
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA,YAAY;AACZ;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,WAAW;AACb;;;AAGA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA,qCAAqC;;AAErC;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY,EAAE,kDAAkD;EAChE,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,YAAY;AACZ;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd","sourcesContent":["\n/* App.css */\nbody {\n  font-family: Arial, sans-serif;\n}\n\nh1 {\n  text-align: center;\n  font-size: larger!important;\n}\n\nbutton {\n  margin: 5px;\n  padding: 10px;\n  font-size: 16px;\n}\n\ndiv {\n  text-align: center;\n}\n\n.journey-map-container {\n  position: relative;\n  display: inline-block;\n}\n\n.journey-map-container img {\n  width: 100%;\n  height: auto;\n}\n\n.clickable-area {\n  position: absolute;\n  cursor: pointer;\n  /* Adjust the width, height, and positioning for each stage */\n}\n\n.stage0 {\n  top: 28%;\n  left: 5%;\n  width: 19%;\n  height: 20%;\n}\n\n\n.stage1 {\n  top: 35%;\n  left: 22%;\n  width: 20%;\n  height: 20%;\n}\n\n.stage2 {\n  top: 55%;\n  left: 23%;\n  width: 16%;\n  height: 20%;\n}\n\n.stage3 {\n  top: 25%;\n  left: 42%;\n  width: 15%;\n  height: 24%;\n}\n\n.stage4 {\n  top: 50%;\n  left: 42%;\n  width: 17%;\n  height: 20%;\n}\n\n.stage5 {\n  top: 40%;\n  left: 60%;\n  width: 17%;\n  height: 17%;\n}\n\n.stage6 {\n  top: 56%;\n  left: 60%;\n  width: 17%;\n  height: 17%;\n}\n\n.stage7 {\n  top: 20%;\n  left: 80%;\n  width: 16%;\n  height: 40%;\n}\n\n/* Add more styles for other stages */\n\n.tooltip {\n  visibility: hidden;\n  background-color: green;\n  color: #fff;\n  text-align: center;\n  border-radius: 5px;\n  padding: 5px;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%; /* Position the tooltip above the clickable area */\n  left: 50%;\n  margin-left: -60px;\n  width: 120px;\n}\n\n.tooltip .tooltip-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n\n.clickable-area {\n  position: absolute;\n  cursor: pointer;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.clickable-area:hover {\n  transform: scale(1.05);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n}\n\n.tooltip p {\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0;\n}\n.tooltip:hover::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: green;\n  color: white;\n  padding: 10px;\n  border-radius: 5px;\n  white-space: nowrap;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n}\n\n.tooltip:hover .tooltip-avatar {\n  display: inline-block;\n}\n\n.tooltip:hover p {\n  visibility: visible;\n  opacity: 1;\n}\n\n.clickable-area:hover .tooltip {\n  visibility: visible;\n}\n\n.stage-content {\n  margin-top: 20px;\n  opacity: 0;\n  animation: fadeIn 1s forwards;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* App.css */\n.journey-map-container {\n  position: relative;\n}\n\n.avatar-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.selected-avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n}\n\n.chat-button {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  background-color: #0078d4;\n  border: none;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  color: white;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
